import { render, staticRenderFns } from "./BarrierService.vue?vue&type=template&id=5294478a&"
import script from "./BarrierService.vue?vue&type=script&lang=js&"
export * from "./BarrierService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports